module.exports = __webpack_public_path__ + "media/images/team/kyriakos-42dbc3c1eae0f56a35b32995adc2f9ac.png";